import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_IModal = _resolveComponent("IModal")!

  return (_openBlock(), _createBlock(_component_IModal, {
    id: "modal-progress",
    ref: "XModal",
    "show-close-button": _ctx.lastMessage?.allowClose ?? false,
    autoshow: "",
    "full-transparent": "",
    "hide-footer": "",
    "show-overlay": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Message, {
        closable: false,
        severity: _ctx.lastMessage?.severity ?? 'info',
        class: "mb-1"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.lastMessage?.message), 1)
        ]),
        _: 1
      }, 8, ["severity"]),
      (_ctx.lastMessage?.showProgressBar ?? true)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            class: "mt-0",
            mode: "indeterminate",
            style: {"height":"3px"}
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show-close-button"]))
}